import React, { useState, useEffect, useRef } from 'react';
// require('flatpickr/dist/themes/light.css')
import VolumeOffIcon from '@/components/Icons/VolumeOnIcon';
import ProgressBar from '@/components/common/ProgressBar.client';
import { useAtom } from 'jotai/index';
import { volumeAtom, isMutedAtom, fixedRadioPlayerAtom } from '../../store';
import { useSetAtom } from 'jotai';

interface VolumeMenuProps {
  label?: string;
  children?: React.ReactNode;
}

const VolumeMenu: React.FC<VolumeMenuProps> = ({ label, children }) => {
  const [volume, setVolume] = useAtom(volumeAtom);
  const setIsMuted = useSetAtom(isMutedAtom);
  const setFixedRadioPlayer = useSetAtom(fixedRadioPlayerAtom);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [menuHeight, setMenuHeight] = useState<number>(0);
  const [transClass, setTransClass] = useState<string>('hidden');
  const [topOffset, setTopOffset] = useState<string>('auto');

  const menuRef = useRef<HTMLInputElement>(null);
  const activatorRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (menuRef && menuRef.current) {
      setMenuHeight(menuRef.current.clientHeight);
      if (menuHeight) {
        setTopOffset(`-${menuHeight / 2}px`);
      }
    }
  }, [menuRef, setMenuHeight, setTopOffset, menuHeight, activatorRef]);

  const toggleOpen = () => {
    const toggleValue = !isOpen;
    setIsOpen(toggleValue);
    setTransClass(toggleValue ? 'flex' : 'hidden');
    setTimeout(() => {
      if (menuRef && menuRef.current) {
        setMenuHeight(menuRef.current.clientHeight);
        if (menuHeight) {
          setTopOffset(`-${menuHeight / 2}px`);
        }
      }
    }, 10);
  };

  const onChange = (volume: number) => {
    setVolume(volume);
    setIsMuted(false);
  };

  return (
    <>
      <div
        ref={activatorRef}
        className="relative flex items-center"
        onMouseDown={() => setFixedRadioPlayer(true)}
        onMouseUp={() => setFixedRadioPlayer(false)}
      >
        <span className="relative flex">
          {label && <span className="mr-2">{label}</span>}
          {
            <button
              onClick={toggleOpen}
              style={{ fontWeight: 600 }}
              className="flex rounded-full p-8 hover:bg-black-25"
            >
              {children || <VolumeOffIcon width="24px" height="24px" strokeColor={'#012447'} />}
            </button>
          }
        </span>
        <div
          ref={menuRef}
          className={`border-gray-300 absolute z-30 flex h-100 flex-col items-center rounded-full border-2 shadow-xl ${transClass}`}
          style={{ right: '-20px', top: `${topOffset}` }}
        >
          <ProgressBar vertical={true} progress={volume} strokeColor={'primary-light-coral'} onChange={onChange} />
        </div>
      </div>
      {isOpen && <div className="fixed bottom-0 left-0 right-0 top-0 z-20" onClick={toggleOpen} />}
    </>
  );
};

export default VolumeMenu;
